/**
 * Request utilities
 * These are initialized with the store's dispatch function via init()
 */
let _dispatch = null;
const requestHelperNotInitialized =
  'Request helpers not initialized. Call request.init(dispatch) first.';

/**
 * Request helper object
 * Provides a clean API for making HTTP requests through the Vuex store
 */
const request = {
  /**
   * Initialize request helpers with the store's dispatch function
   * This should be called once when the store is created
   * @param {Function} dispatch - Vuex store dispatch function
   */
  init(dispatch) {
    _dispatch = dispatch;
  },

  /**
   * Make a GET request
   * @param {string} url - The URL to request
   * @param {Object} options - Additional request options (errorMessage, successMessage, loadingMutation, etc.)
   * @returns {Promise} The response object or undefined on error
   */
  get(url, options = {}) {
    if (!_dispatch) {
      console.error(requestHelperNotInitialized);
      return Promise.resolve(undefined);
    }
    return _dispatch('request/get', { url, ...options }, { root: true });
  },

  /**
   * Make a POST request
   * @param {string} url - The URL to request
   * @param {*} data - The data to send in the request body
   * @param {Object} options - Additional request options (errorMessage, successMessage, loadingMutation, etc.)
   * @returns {Promise} The response object or undefined on error
   */
  post(url, data, options = {}) {
    if (!_dispatch) {
      console.error(requestHelperNotInitialized);
      return Promise.resolve(undefined);
    }
    return _dispatch('request/post', { url, data, ...options }, { root: true });
  },

  /**
   * Make a PUT request
   * @param {string} url - The URL to request
   * @param {*} data - The data to send in the request body
   * @param {Object} options - Additional request options (errorMessage, successMessage, loadingMutation, etc.)
   * @returns {Promise} The response object or undefined on error
   */
  put(url, data, options = {}) {
    if (!_dispatch) {
      console.error(requestHelperNotInitialized);
      return Promise.resolve(undefined);
    }
    return _dispatch('request/put', { url, data, ...options }, { root: true });
  },

  /**
   * Make a DELETE request
   * @param {string} url - The URL to request
   * @param {Object} options - Additional request options (errorMessage, successMessage, loadingMutation, etc.)
   * @returns {Promise} The response object or undefined on error
   */
  delete(url, options = {}) {
    if (!_dispatch) {
      console.error(requestHelperNotInitialized);
      return Promise.resolve(undefined);
    }
    return _dispatch('request/delete', { url, ...options }, { root: true });
  },
};

export default request;
